<template>
  <header class="page-header">
    <h1>Sleep Content</h1>
    <div class="header-controls">
      <div class="search-box" :class="{ active: searchTerm || searchFocused }">
        <i class="icon-search"></i>
        <input 
          v-model="searchTerm" 
          type="text" 
          placeholder="Search content..." 
          @input="handleSearch"
          @focus="searchFocused = true"
          @blur="searchFocused = false"
        >
        <button v-if="searchTerm" @click="clearSearch" class="clear-button">
          <i class="icon-close"></i>
        </button>
      </div>
      
      <div class="filter-box">
        <select v-model="selectedType" @change="handleTypeChange">
          <option value="">All Types</option>
          <option value="bedtime">Bedtime Story</option>
          <option value="breathing">Breathing Exercise</option>
          <option value="sleep_frequency">Sleep Frequency</option>
          <option value="souds_of_nature">Sounds of Nature</option>
          <option value="brain_programming">Brain Programming</option>
        </select>
      </div>
      
      <div class="view-toggle">
        <button 
          @click="toggleView('grid')" 
          :class="['view-btn', { active: viewMode === 'grid' }]"
          aria-label="Grid view"
        >
          <i class="icon-grid"></i>
        </button>
        <button 
          @click="toggleView('table')" 
          :class="['view-btn', { active: viewMode === 'table' }]"
          aria-label="Table view"
        >
          <i class="icon-table"></i>
        </button>
      </div>
      
      <button @click="$emit('create')" class="btn-primary">
        <i class="icon-plus"></i> New Item
      </button>
      
      <!-- <button @click="$emit('debug-auth')" class="btn-secondary">
        <i class="icon-info"></i> Debug Auth
      </button> -->
    </div>
  </header>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'SleepContentHeader',
  props: {
    currentView: {
      type: String,
      default: 'grid'
    }
  },
  emits: ['search', 'type-change', 'clear-search', 'create', 'debug-auth', 'view-change'],
  setup(props, { emit }) {
    const searchTerm = ref('')
    const searchFocused = ref(false)
    const selectedType = ref('')
    const viewMode = ref(props.currentView)
    
    const handleSearch = () => {
      emit('search', searchTerm.value)
    }
    
    const clearSearch = () => {
      searchTerm.value = ''
      emit('clear-search')
    }
    
    const handleTypeChange = () => {
      emit('type-change', selectedType.value)
    }
    
    const toggleView = (mode) => {
      viewMode.value = mode
      emit('view-change', mode)
    }
    
    return {
      searchTerm,
      searchFocused,
      selectedType,
      viewMode,
      handleSearch,
      clearSearch,
      handleTypeChange,
      toggleView
    }
  }
}
</script>

<style scoped>
.view-toggle {
  display: flex;
  background: var(--divider-color);
  border-radius: var(--radius);
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.view-btn {
  background: none;
  border: none;
  padding: var(--spacing-2) var(--spacing-3);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.view-btn.active {
  background-color: var(--primary-color);
  color: white;
}

.view-btn:not(.active):hover {
  background-color: var(--border-color);
  color: var(--text-primary);
}

.icon-grid:before { content: "⠿"; }
.icon-table:before { content: "☰"; }
</style> 